import Box from '@mui/material/Box';
import { FC, PropsWithChildren } from 'react';

interface IAdminProviderProps extends PropsWithChildren { }

const AdminProvider: FC<IAdminProviderProps> = ({
    children
}) => {
    return (
        <Box>
            {children}
        </Box>
    );
}

export default AdminProvider;